import { Route, Routes as RouterRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { NavBar } from "../../components/ui";
import useUser from "../../hooks/useUser";
import AuthRoute from "../../components/AuthRoute";
import routes from "./routes";
import { Portal } from "../../util";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";

const Body = props => (
  <Sentry.ErrorBoundary
    fallback={createModuleErrorBoundary("admin")}
    beforeCapture={scope => {
      scope.setTag("module", "admin");
    }}
  >
    <RouterRoutes>
      {routes
        ?.filter?.(item => item?.element)
        ?.map((item, key) => (
          <Route
            key={key}
            path={item.href}
            element={
              <AuthRoute permissions={item.permissions}>
                <item.element {...props} />
              </AuthRoute>
            }
          />
        ))}
    </RouterRoutes>
  </Sentry.ErrorBoundary>
);

const Admin = props => {
  const { user } = useUser();

  return (
    <div className="relative min-h-full w-full">
      <Portal id="sidebar">
        <NavBar
          navigation={routes?.filter?.(item => item?.icon)}
          open={props?.open}
        />
      </Portal>
      <Body {...props} user={user} />
    </div>
  );
};

export default Admin;
